import * as anchor from "@project-serum/anchor";
import { MintCountdown } from "./MintCountdown";
import { toDate, formatNumber } from "./utils";
import { CandyMachineAccount } from "./candy-machine";

type HeaderProps = {
	candyMachine?: CandyMachineAccount;
};

export const Header = ({ candyMachine }: HeaderProps) => {
	return (
		<div className='flex-center'>
			<div>
				<MintCountdown
					date={toDate(
						candyMachine?.state.goLiveDate
							? candyMachine?.state.goLiveDate
							: candyMachine?.state.isPresale
							? new anchor.BN(new Date().getTime() / 1000)
							: undefined
					)}
					style={{ justifyContent: "flex-end" }}
					status={
						!candyMachine?.state?.isActive || candyMachine?.state?.isSoldOut
							? "COMPLETED"
							: candyMachine?.state.isPresale
							? "PRESALE"
							: "LIVE"
					}
				/>
			</div>
			{candyMachine && (
				<div>
					<h3 className="min">{`${2500 - candyMachine?.state.itemsRemaining}`}/2500 Minted</h3>
				</div>
			)}
		</div>
	);
};

const getMintPrice = (candyMachine: CandyMachineAccount): string => {
	const price = formatNumber.asNumber(
		candyMachine.state.isPresale &&
			candyMachine.state.whitelistMintSettings?.discountPrice
			? candyMachine.state.whitelistMintSettings?.discountPrice!
			: candyMachine.state.price!
	);
	return `${price}`;
};
